import { RunChangeV2Node } from "./gql";

export enum RunChangesStatus {
  PLANNED = "PLANNED",
  SUCCESSFUL = "SUCCESSFUL",
  FAILED = "FAILED",
  UNCHANGED = "UNCHANGED",
  UNPLANNED = "UNPLANNED",
}

export type RunChangesItem = RunChangeV2Node & {
  status: RunChangesStatus;
};
